import { useState } from "react";
import { ArrowLeft, ArrowRight, ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { TOUR, presentingKey, launchDemo, exitPresentation } from "@/lib/showcaseTour";

// Slim presentation bar shown instead of the console chrome while a Showcase demo is running.
export default function PresentBar() {
  const key = presentingKey();
  const [busy, setBusy] = useState(false);
  const idx = TOUR.findIndex((t) => t.key === key);
  const step = TOUR[idx];
  const next = TOUR[idx + 1];
  if (!step) return null;
  const goNext = async () => {
    setBusy(true);
    try { await launchDemo(next.key); } catch (e) { toast.error(e.response?.data?.detail || "Could not open next demo"); setBusy(false); }
  };
  return (
    <div className="sticky top-0 z-[100] flex items-center gap-3 px-3 sm:px-4 h-11 text-white" style={{ background: "#0052CC" }} data-testid="present-bar">
      <button type="button" onClick={exitPresentation} className="inline-flex items-center gap-1.5 mono text-[10px] uppercase tracking-widest hover:opacity-80" data-testid="present-back">
        <ArrowLeft className="w-3.5 h-3.5" /> <span className="hidden sm:inline">Back to</span> Showcase
      </button>
      <div className="flex-1 flex items-center justify-center gap-2 min-w-0">
        <ShieldCheck className="w-4 h-4 shrink-0" />
        <span className="heading font-black uppercase tracking-wide text-sm sm:text-base truncate" data-testid="present-title">{step.title}</span>
        <span className="mono text-[10px] opacity-70 shrink-0">{idx + 1} / {TOUR.length}</span>
      </div>
      {next ? (
        <button type="button" onClick={goNext} disabled={busy} className="inline-flex items-center gap-1.5 mono text-[10px] uppercase tracking-widest bg-white/15 hover:bg-white/25 px-2.5 py-1.5 disabled:opacity-60" data-testid="present-next">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : null} <span className="hidden sm:inline">Next ·</span> {next.title} <ArrowRight className="w-3.5 h-3.5" />
        </button>
      ) : (
        <button type="button" onClick={exitPresentation} className="mono text-[10px] uppercase tracking-widest bg-white/15 hover:bg-white/25 px-2.5 py-1.5" data-testid="present-finish">Finish</button>
      )}
    </div>
  );
}
